import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import usePlayerSelector from '../../../../utils/usePlayerSelector';
import CatcherWristband from './CatcherWristband';
import MatchupPitcherSelector from '../../Player/MatchupPitcherSelector';

const WristbandReport = ({ match: { params: { teamId: vsTeamId } }, playerTeamStartingPitchers }) => {
    const { t: translate } = useTranslation();
    const playerUser = usePlayerSelector();
    const [selectedPitcher, setSelectedPitcher] = useState(!playerUser.IsPitcher && playerTeamStartingPitchers?.length
        ? { ...playerTeamStartingPitchers[0], name: playerTeamStartingPitchers[0].FullName, value: playerTeamStartingPitchers[0].PlayerID }
        : {});
    const { PlayerID: pitcherId, Throws: throws, FullName: name } = (!playerUser.IsPitcher ? (selectedPitcher || {}) : playerUser);
    return (
        <div>
            {!playerUser.IsPitcher && (
                <div className="d-flex align-items-center justify-content-end mb-3">
                    <b className="me-1">{translate('common.select-a-pitcher')}:</b>
                    <MatchupPitcherSelector
                        onSelect={setSelectedPitcher}
                    />
                </div>
            )}
            {pitcherId && (
                <CatcherWristband
                    teamId={Number(playerUser.Team.TeamID)}
                    vsTeamId={Number(vsTeamId)}
                    pitcherId={pitcherId}
                    pitcherName={name}
                    pitcherThrows={throws}
                    perspective={!playerUser.IsPitcher ? 'catcher' : 'pitcher'}
                />
            )}
        </div>
    );
};

WristbandReport.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    playerTeamStartingPitchers: PropTypes.arrayOf(PropTypes.shape({
        PlayerID: PropTypes.number.isRequired,
        FullName: PropTypes.string.isRequired,
    })),
};
WristbandReport.defaultProps = {
    playerTeamStartingPitchers: [],
};

export default WristbandReport;
